export default __webpack_public_path__ + "static/media/img_fee_25.488f17c6.svg";